export default __webpack_public_path__ + "static/media/coventry-bg.44b096cd.jpg";